import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokensService } from '@geneplanet/ngx-auth0';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { IGNORE_SENTRY } from 'src/app/core/interceptors/http-interceptor';
import { environment } from 'src/environments/environment';
import {
  CreateAccount,
  CreateAccountResponse,
  ResetPassword,
} from '../interfaces/accounts.types';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  newPassword$ = new BehaviorSubject<any>(false);

  constructor(
    private http: HttpClient,
    private readonly tokenService: TokensService
  ) {}

  check(email: string, pass: string): Observable<any> {
    return this.http
      .post<any>(`${environment.api}/accounts/token`, {
        username: email,
        password: pass,
        audience: environment.auth0.audience,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        client_id: environment.auth0.clientID,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        grant_type: 'http://auth0.com/oauth/grant-type/password-realm',
        realm: 'Username-Password-Authentication',
        scope: 'openid offline_access',
      }, {
        context: new HttpContext().set(IGNORE_SENTRY, true),
      })
      .pipe(
        map((token) => {
          return {
            accessToken: token.access_token,
            expiresIn: token.expires_in,
            idToken: token.id_token,
            refreshToken: token.refresh_token,
            scope: token.scope,
            tokenType: token.token_type,
          };
        }),
        tap((token) => this.tokenService.set(JSON.stringify(token)))
      );
  }

  create(
    account: Omit<CreateAccount, 'skipEmailVerification' | 'type'>
  ): Observable<CreateAccountResponse> {
    return this.http.post<CreateAccountResponse>(
      `${environment.api}/accounts`,
      account
    );
  }

  createNipt(email: string, password: string, reference: string) {
    const data = {
      email,
      password,
      reference,
    };
    return this.http.post(`/api/nipt-online/register`, data);
  }

  reset(reset: ResetPassword): Observable<any> {
    return this.http.post<ResetPassword>(
      `${environment.api}/accounts/reset`,
      reset
    );
  }

  password(password: string): Observable<any> {
    return this.http.post<any>(
      `${environment.api}/accounts/password/new`,
      password
    );
  }

  verify(token: string): Observable<void> {
    return this.http.get<void>(
      `${environment.api}/accounts/password/verify?token=${token}`
    );
  }

  resend(): Observable<null> {
    return this.http.get<null>(`${environment.api}/accounts/verify`);
  }
}
